import React, {Fragment} from 'react';
import {bindActionCreators} from "redux";
import {connect} from 'react-redux';
import {Button} from "../components/Button";
import Title from "../components/Title";
import {config} from "../../config";
import Helmet from "react-helmet";
import createLink from "../../libs/createLink";
import {Link} from "react-router-dom";
import {sendForgotPassword} from "../../creators/user.forgotPassword";



class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            sent: false
        }
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(event){
        event.preventDefault();
        event.stopPropagation();
        let username = this.state.username.trim();
        this.props.sendForgotPassword({username});
        this.setState({username : "", sent : true});
    }

    render() {
        return (
            <div id="forgot-password">
                <Helmet>
                    <title>{config.preTitle}Mot de passe oublié{config.postTitle}</title>
                </Helmet>
                <div className="container">
                    <div className="card">
                        <div className="main-wrapper">
                            <Title heading={"heading-2"} display={"display-2"}>Récupérer mon mot de passe</Title>
                            {!this.state.sent
                                ? (
                                    <Fragment>
                                        <form className="form-forgot-password" onSubmit={(event) =>this.onSubmit(event)}>
                                            <input type="text" placeholder="Votre e-mail ou votre nom d'utilisateur" value={this.state.username} onChange={(e) => this.setState({username : e.target.value})}/>
                                            <Button className={"full"}
                                                    btnType={"submit"}
                                                    size={"medium"}
                                                    btnStyle={"primary-reverse"}
                                                    content={"Envoyer"}/>
                                        </form>
                                        <div className="text">
                                            <p>
                                                Si vous avez perdu votre mot de passe, vous pouvez utiliser ce formulaire pour le ré-initialiser. Saisissez simplement votre adresse e-mail ou votre nom d'utilisateur dans le champ ci-dessus.
                                            </p>
                                            <p>
                                                Vous recevrez alors un courriel pour s'assurer que cette demande est bien à votre initiative. Ce courriel contiendra un lien sur lequel vous devrez cliquer pour terminer la procédure.
                                            </p>
                                        </div>
                                    </Fragment>
                                ) : (
                                    <div className="text">
                                        <p>
                                            Nous venons de vous envoyer un courriel <b>{this.props.userForgotPassword.email && `(${this.props.userForgotPassword.email})`}</b> pour s'assurer que cette demande est bien à votre initiative. Merci de cliquer sur le lien qu'il contient pour terminer la procédure.
                                        </p>
                                    </div>
                                )
                            }
                            <div className="text">
                                <p>Si vous avez le moindre problème n’hésitez pas à nous <Link to={createLink("contact")}>contacter</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    userForgotPassword: state.userForgotPassword.data,
    userForgotPasswordInitialized: state.userForgotPassword.initialized
});


const mapDispatchToProps = (dispatch) => bindActionCreators({
    sendForgotPassword
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);

